<template>
  <nav
    class="inline-flex items-center px-4 pb-6 pt-2 font-body text-sm font-normal mobile:hidden desktop:mb-8 desktop:p-0"
    aria-label="SF Breadcrumbs"
  >
    <ol class="group flex w-auto flex-wrap leading-none">
      <li
        v-for="item in breadcrumbs"
        :key="item.text"
        class="peer items-center text-neutral-400 last-of-type:flex last-of-type:font-medium peer-[:nth-of-type(1)]:before:px-2 peer-[:nth-of-type(1)]:before:leading-5 peer-[:nth-of-type(1)]:before:content-['/'] sm:flex"
      >
        <NuxtLink
          :to="item.link"
          variant="secondary"
          class="whitespace-nowrap leading-5 text-inherit no-underline outline-secondary-600 hover:text-primary-700 hover:underline active:underline"
        >
          {{ item.text }}
        </NuxtLink>
      </li>
    </ol>
  </nav>
</template>

<script lang="ts" setup>
import { useSSR } from '~/composables/useSSR/useSSR';

interface Props {
  breadcrumbs: any[];
}

const props = withDefaults(defineProps<Props>(), {
  breadcrumbs: () => [],
});

const { onSSR } = useSSR();
const { setBreadcrumbsInfo } = useSeo();

onSSR(() => {
  setBreadcrumbsInfo(props.breadcrumbs);
});
</script>
